import React, { useContext, useEffect } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import DropZone from '@react/react-spectrum/DropZone'
import Button from '@react/react-spectrum/Button'
import Delete from '@react/react-spectrum/Icon/Delete'
import IllustratedMessage from '@react/react-spectrum/IllustratedMessage'
import { warning } from '@react/react-spectrum/Toast'
import filesize from 'filesize' 
import analytics from '../config/analytics'

export default function DemoDragDrop () {
    const { selectedFiles, thumbs, dispatch, page } = useContext(DemoContext)
    const expectedFileSize = 1024 * 1024 * 10; //10mb
    
    useEffect(() => {
        getThumbs()
    }, [thumbs, selectedFiles])

    function browse(e) {
        document.getElementById('inputBrowse').click()
    }

    function clickUpload(e) {
        let broowsedFiles = []
        e.preventDefault()
        if (e.target && e.target.files) {
            analytics.sendEventName('click', `${page}:selectfile`)
            broowsedFiles = e.target.files
        } else if (e.dataTransfer && e.dataTransfer.files) {
            analytics.sendEventName('click', `${page}:dragfile`)
            broowsedFiles = e.dataTransfer.files
        }
        // const joined = Array.from(curFiles).concat(Array.from(broowsedFiles));
        // setBroowsedFiles(joined)

        let funcArray = []
        for (var x = 0; x < broowsedFiles.length; x++) {
            // console.debug(`broowsedFiles[x].size: ${broowsedFiles[x].size}`)
            // console.debug(`expectedFileSize: ${expectedFileSize}`)
            if (broowsedFiles[x].size > expectedFileSize) {
                warning(`${broowsedFiles[x].name} is too large (${filesize(broowsedFiles[x].size, { round: 0 })}). The maximum file size is ${filesize(expectedFileSize, { round: 0 })}.`)
                funcArray = []
                return
            } else {
                funcArray.push(broowsedFiles[x])
            }
        }
        dispatch({ type: 'set-selectedFiles', payload: { selectedFiles: funcArray } })
    }

    async function getThumbs(){
        if (selectedFiles.length > 0) {
            const promises = selectedFiles.map((blob) => {
                return new Promise((res) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = (e) => {
                    if (e.target) {
                        res(e.target.result)
                    } else {
                        res(e.result)
                    }
                }
                });
            });
            const thumbs = await Promise.all(promises);
            dispatch({ type: 'set-thumbs', payload: { thumbs: thumbs } })
        }
    }

    function deleteAll(e) {
        analytics.sendEventName('click', `${page}:deleteall`)
        e.preventDefault()
        dispatch({ type: 'reset' })
        // dispatch({ type: 'set-selectedFiles', payload: { selectedFiles: [] } })
        // dispatch({ type: 'set-refineFiles', payload: { refineFiles: [] } })
        // dispatch({ type: 'set-page', payload: { page } })
    }

    if (selectedFiles && selectedFiles.length > 0 && thumbs && thumbs.length > 0) {
        let count = 0
        const imgs = thumbs.map( thumb => {
            // const uuid = uuidv4()
            count++
            return <img alt={thumb} key={count} src={thumb} width="300px" height="auto"/>
        })
        return <DropZone onDrop={(e) => clickUpload(e)}>
            <div className='input-thumbs'>{imgs}</div>
            <div className='delete-icon'>
                <Button variant="tool" icon={<Delete size="S"/>} onClick={ e => deleteAll(e) } />
            </div>
        </DropZone>
    } else {
        return <div className='adobe-app-drag-drop'>
            <input
                className='hide'
                type="file"
                id="inputBrowse" name="input"
                onChange={ e => clickUpload(e) }
                accept="image/png, image/jpeg"
                multiple></input>
            <DropZone onDrop={(e) => clickUpload(e)}>
                <IllustratedMessage
                heading="Drag and Drop Your Files"
                description={<div><a href="#" onClick={ e => browse(e) }>Select a file</a> from your computer.</div>}
                illustration={<svg height="110" viewBox="0 0 199 97.7"><g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="3px"><path d="M110.53,85.66,100.26,95.89a1.09,1.09,0,0,1-1.52,0L88.47,85.66" /><line x1="99.5" x2="99.5" y1="95.5" y2="58.5"/><path d="M105.5,73.5h19a2,2,0,0,0,2-2v-43" /><path d="M126.5,22.5h-19a2,2,0,0,1-2-2V1.5h-31a2,2,0,0,0-2,2v68a2,2,0,0,0,2,2h19" /><line x1="105.5" x2="126.5" y1="1.5" y2="22.5"/><path d="M139.5,36.5H196A1.49,1.49,0,0,1,197.5,38V72A1.49,1.49,0,0,1,196,73.5H141A1.49,1.49,0,0,1,139.5,72V32A1.49,1.49,0,0,1,141,30.5H154a2.43,2.43,0,0,1,1.67.66l6,5.66" /><rect height="39" rx="2" ry="2" width="58" x="1.5" y="34.5"/><path d="M47.93,50.49a5,5,0,1,0-4.83-5A4.93,4.93,0,0,0,47.93,50.49Z" strokeWidth="2px"/><path d="M36.6,65.93,42.05,60A2.06,2.06,0,0,1,45,60l12.68,13.2" strokeWidth="2px"/><path d="M3.14,73.23,22.42,53.76a1.65,1.65,0,0,1,2.38,0l19.05,19.7" strokeWidth="2px"/></g></svg>} />
            </DropZone>
        </div>
    }
}
